import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/analy_back.png";
import { StaticImage } from "gatsby-plugin-image";

const Companalysis = () => {
  return (
    <div
      className="comp_analysis p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Competitor Analysis</h2>
            <p>
              In this section, we will conduct a comparative analysis of four
              prominent applications: WeChat, Paytm, Careem Super App, and Gojek
              with Yeppy, aiming to uncover valuable insights.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
            <div className="analy_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/analy_table.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1414}
              />
              <StaticImage
                src="../../../images/case-studies/yeppy/table_mob_view.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1234}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Companalysis;
